import React, {useContext, useState} from 'react';
import {Button, CollapsibleSection, SelectInput, Size, TextArea, TextInput} from "@dts-soldel/dts-react-common";
import {observer} from "mobx-react";
import PropTypes from "prop-types";
import IconSimpleInput from "../IconSimpleInput/IconSimpleInput";
import MobXContext from "../../../../app/mobx/MobXContext";
import HelpIcon from "../../HelpIcon/HelpIcon";
import HelpText from "../../HelpIcon/HelpText";
import MenuInput from "./MenuInput";
import Icons from "../../../../misc/Icon";
import menuFieldChanged from "./menuFieldChanged";

const propTypes = {
	allowSubMenuItems: PropTypes.bool.isRequired,
	menuItem: PropTypes.object.isRequired,
};
const defaultProps = {};

const MenuItemInput = ({allowSubMenuItems, menuItem}) => {
	const {configuratorStore} = useContext(MobXContext);
	const [isCollapsed, setIsCollapsed] = useState(true);

	return (
		<div className="menu-input__container">
			<CollapsibleSection
				clickSection={() => setIsCollapsed(prevIsCollapsed => !prevIsCollapsed)}
				expanded={isCollapsed}
				title="Menu Item"
				collapsibleIndicator={Icons.iconArrowRight()}
			>
				<div className="menu-input__header">
					<Button
						label="Delete Menu Item"
						onClick={() => configuratorStore.deleteMenuItem(menuItem)}
					/>
				</div>
				<TextInput
					size={Size.FULL_WIDTH}
					field="text"
					label="Menu Text"
					value={menuItem.text}
					onChange={(field, value) => menuFieldChanged(menuItem, field, value)}
					children={
						<HelpIcon
							popOverText={HelpText.menuText}
							onUseExampleField="text"
							onUseExampleFieldValue={(field, value) => menuFieldChanged(menuItem, field, value)}
						/>
					}
				/>

				<TextInput
					size={Size.FULL_WIDTH}
					field="url"
					label="URL"
					value={menuItem.url}
					onChange={(field, value) => menuFieldChanged(menuItem, field, value)}
					children={
						<HelpIcon
							popOverText={HelpText.menuUrl}
							onUseExampleField="url"
							onUseExampleFieldValue={(field, value) => menuFieldChanged(menuItem, field, value)}
						/>
					}
				/>

				<SelectInput
					size={Size.FULL_WIDTH}
					field="selected"
					label="Selected"
					options={[
						{label: 'No', value: false},
						{label: 'Yes', value: true},
					]}
					value={menuItem.selected}
					onChange={(field, value) => menuFieldChanged(menuItem, field, value)}
					children={
						<HelpIcon
							popOverText={HelpText.menuSelected}
							onUseExampleField="selected"
							onUseExampleFieldValue={(field, value) => menuFieldChanged(menuItem, field, value)}
						/>
					}
				/>

				<SelectInput
					size={Size.FULL_WIDTH}
					field="openInNewTab"
					label="Open In New Tab"
					options={[
						{label: 'No', value: false},
						{label: 'Yes', value: true},
					]}
					value={menuItem.openInNewTab}
					onChange={(field, value) => menuFieldChanged(menuItem, field, value)}
					children={
						<HelpIcon
							popOverText={HelpText.menuOpenInNewTab}
							onUseExampleField="openInNewTab"
							onUseExampleFieldValue={(field, value) => menuFieldChanged(menuItem, field, value)}
						/>
					}
				/>

				<SelectInput
					size={Size.FULL_WIDTH}
					field="open"
					label="Open"
					options={[
						{label: 'No', value: false},
						{label: 'Yes', value: true},
					]}
					value={menuItem.open}
					onChange={(field, value) => menuFieldChanged(menuItem, field, value)}
					children={
						<HelpIcon
							popOverText={HelpText.menuOpen}
							onUseExampleField="open"
							onUseExampleFieldValue={(field, value) => menuFieldChanged(menuItem, field, value)}
						/>
					}
				/>

				<TextArea
					size={Size.FULL_WIDTH}
					field="onClick"
					label="onClick"
					value={menuItem.onClick}
					onChange={(field, value) => menuFieldChanged(menuItem, field, value)}
					children={
						<HelpIcon
							popOverText={HelpText.menuOnClick}
							onUseExampleField="onClick"
							onUseExampleFieldValue={(field, value) => menuFieldChanged(menuItem, field, value)}
						/>
					}
				/>

				<IconSimpleInput
					label="Menu Icon"

					domValue={menuItem.iconDom}
					functionValue={menuItem.iconFunction}
					iconType={menuItem.iconType}
					stringValue={menuItem.iconString}
					urlValue={menuItem.iconUrl}

					onDomValueChange={value => menuFieldChanged(menuItem, 'iconDom', value)}
					onFunctionValueChange={value => menuFieldChanged(menuItem, 'iconFunction, value')}
					onStringValueChange={value => menuFieldChanged(menuItem, 'iconString', value)}
					onTypeChange={value => menuFieldChanged(menuItem, 'iconType', value)}
					onUrlValueChange={value => menuFieldChanged(menuItem, 'iconUrl', value)}
					popOverTextKey="menu"
				/>
				{
					allowSubMenuItems ?
						<div className="menu-input__header">
							<Button
								label="Add Sub Menu Item"
								onClick={() => configuratorStore.addMenuItemToMenu(menuItem.children)}
							/>
						</div>
						: undefined
				}
				{
					(menuItem.children && menuItem.children.length) ?
						<MenuInput menu={menuItem.children} allowSubMenuItems={allowSubMenuItems}/>
						: undefined
				}
			</CollapsibleSection>
		</div>
	);
};

MenuItemInput.propTypes = propTypes;
MenuItemInput.defaultProps = defaultProps;

export default observer(MenuItemInput);
